import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import { useRole } from "components/Hooks/UserHooks";
import {
  AGENCY_APP_NAME_OPTION,
  AGENCY_BRANCH_STATUS_OPTION,
  COLOR_AGENCY_BRANCH_STATUS,
  COLOR_STATUS_ACTIVE_DISABLE,
  COLOR_STATUS_CAMPAIGN,
  ENUM_STATUS_CAMPAIGN,
  getOptionImage,
  LIST_CHANNEL_OPTION,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
  LIST_STATUS_CAMPAIGN_OPTION,
  STATUS_ACTIVE_DISABLE_OPTION,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import CollapseFilter from "components/Common/CollapseFilter";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import ModalPreview from "components/Common/ModalPreview";
import CampaignForm from "./CampaignForm";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import CopyWrapper from "components/Common/CopyWrapper";
import { truncate } from "utils";
import { getAgencyCampaignList } from "store/agencyCampaign/thunk";
import { QRCodeCanvas } from "qrcode.react";
import ModalPreviewQRCode from "components/Common/ModalPreviewQRCode";
import DropdownChannel from "components/Common/DropdownChannel";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import agencyApi from "api/agencyApi";
import CoundownTime from "components/Common/CoundownTime";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const CampaignList = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
    start_campaign_date: withDefault(StringParam, ""),
    end_campaign_date: withDefault(StringParam, ""),
    channel: withDefault(StringParam, ""),
    app_name: withDefault(StringParam, ""),
    campaign_status: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [previewQRCode, setPreviewQRCode] = useState<any>(null);

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;
  const [dateCampaignSearch, setDateCampaignSearch] = useState<any[]>([
    query?.start_campaign_date
      ? moment(query?.start_campaign_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_campaign_date
      ? moment(query?.end_campaign_date || "", "Y-MM-DD").toDate()
      : null,
  ]);
  const [startCampaignDate, endCampaignDate] = dateCampaignSearch;
  const [keywordSearch, setKeywordSearch] = useState<string>(
    query?.keyword || ""
  );
  const [statusSearch, setStatusSearch] = useState<Option | any>(
    LIST_OPTION_BAR_LIST_OPEN_STATUS?.find(
      (item) => item?.value === query?.status
    )?.value || ""
  );
  const [statusCampaignSearch, setStatusCampaignSearch] = useState<
    Option | any
  >(
    LIST_STATUS_CAMPAIGN_OPTION?.find((item) => item?.value === query?.status)
      ?.value || ""
  );
  const [channelSearch, setChannelSearch] = useState<Option | any>(
    LIST_CHANNEL_OPTION?.find((item) => item?.value === query?.channel)
      ?.value || ""
  );
  const [appNameSearch, setAppNameSearch] = useState<Option | any>(
    AGENCY_APP_NAME_OPTION?.find((item) => item?.value === query?.app_name)
      ?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.AgencyCampaign;
  const AgencyProperties = createSelector(selectLayoutState, (state) => ({
    lstCampaign: state.lstCampaign,
    isCampaignLoading: state.isCampaignLoading,
    isCampaignSuccess: state.isCampaignSuccess,
    error: state.error,
  }));

  // Inside your component
  const { lstCampaign, isCampaignLoading } = useSelector(AgencyProperties);

  function loadTableData() {
    dispatch(getAgencyCampaignList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      keyword: keywordSearch,
      status: statusSearch,
      campaign_status: statusCampaignSearch,
      channel: channelSearch,
      app_name: appNameSearch,
      // start_date: startDate
      //   ? moment(new Date(startDate)).startOf("day").format("Y-MM-DD HH:mm:ss")
      //   : "",
      // end_date: endDate ? moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss") : "",
      start_date: startDate
        ? formatDateStringToUTC(
            moment(new Date(startDate))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      end_date: endDate
        ? formatDateStringToUTC(
            moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        start_date: "",
        end_date: "",
        status: "",
        campaign_status: "",
        channel: "",
        app_name: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setKeywordSearch((_prev) => "");
    setStatusSearch((_prev: any) => "");
    setStatusCampaignSearch((_prev: any) => "");
    setChannelSearch((_prev: any) => "");
    setAppNameSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    status: number | string;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await agencyApi.updateAgencyCampaign(item?.id, {
        status: item?.status,
      });

      if (response?.code === 200) {
        dispatch(getAgencyCampaignList(query));
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "60px" }}>
              {lstCampaign?.meta?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        thWidth: 140,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                checked={cell?.value == 1 ? true : false}
                onChange={(e) => {
                  e?.preventDefault();
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({ id: item?.id, status: (value == true ? 1 : 2) });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Linked Branch IO"),
        accessor: "branch_link_status",
        thWidth: 180,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_AGENCY_BRANCH_STATUS[cell?.value] || "secondary"
                }`}
              >
                {t(
                  AGENCY_BRANCH_STATUS_OPTION?.find(
                    (item: any) => item?.value === cell?.value
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Campaign Status"),
        accessor: "campaign_status",
        thWidth: 180,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const endDate = formatDateStringToKorea(item?.end_date);

          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_STATUS_CAMPAIGN[cell?.value] || "secondary"
                }`}
              >
                {t(
                  LIST_STATUS_CAMPAIGN_OPTION?.find(
                    (item: any) => item?.value === cell?.value
                  )?.label || ""
                )}
              </span>
              {item?.campaign_status !== ENUM_STATUS_CAMPAIGN.END && (
                <CoundownTime expireDate={endDate} />
              )}
            </div>
          );
        },
      },
      {
        Header: t("QR Code"),
        accessor: "qr_code",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          
          let branch_link = item?.branch_link;
          const agencyParams = item?.params;
          if(agencyParams && branch_link) {
            branch_link = `${branch_link}&${agencyParams}`
          }

          return (
            branch_link && (
              <>
                <div
                  className="cursor-pointer"
                  onClick={() => setPreviewQRCode(item)}
                >
                  <QRCodeCanvas value={branch_link} size={80} />
                </div>
              </>
            )
          );
        },
      },
      {
        Header: t("Branch Link"),
        accessor: "branch_link",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 240,
        Cell: (cell: any) => {
          let branch_link = cell?.value;
          const agencyParams = cell?.row?.original?.params;
          if(agencyParams && branch_link) {
            branch_link = `${branch_link}&${agencyParams}`
          }

          return (
            branch_link && (
              <div
                className="cursor-pointer text-primary"
                style={{ maxWidth: "220px" }}
              >
                <CopyWrapper
                  contentCopy={branch_link}
                  style={{ minWidth: "70px" }}
                >
                  {(branch_link)}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Custom Parameters"),
        accessor: "agency_params",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const agency_params = cell?.value;
          return (
            agency_params?.length > 0 && (
              <>
                {agency_params?.map((item: any) => {
                  return (
                    <div className="d-flex align-items-center whitespace-nowrap">
                      <div>{item?.param_key}</div>
                      <span>{`=`}</span>
                      <div>{item?.param_value}</div>
                    </div>
                  );
                })}
              </>
            )
          );
        },
      },
      {
        Header: t("App"),
        accessor: "app_name",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          const item = cell?.value;
          let imgAppName = getOptionImage(item);

          return (
            item && (
              <div className="d-flex align-items-center whitespace-nowrap">
                {imgAppName ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgAppName ? (
                      <img
                        src={imgAppName}
                        width={20}
                        height={20}
                        alt="platform"
                      />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    AGENCY_APP_NAME_OPTION?.find(
                      (item: any) => item?.value === cell?.value
                    )?.label || ""
                  )}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: t("Campaign Code"),
        accessor: "referral_code",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 120,
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer" style={{ minWidth: "180px" }}>
                {cell?.value}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Campaign Name"),
        accessor: "name",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 120,
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer" style={{ minWidth: "180px" }}>
                {cell?.value}
              </div>
            </>
          );
        },
      },
      {
        Header: `${t("Agency")}`,
        accessor: "AgencyName",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.agency;
          return (
            item && (
              <div className="text-center">
                <div>{item?.agency_name}</div>
                <div className="text-primary">{item?.referral_code}</div>
              </div>
            )
          );
        },
      },
      {
        Header: t("Channel"),
        accessor: "channel",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const name = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 100 }}>
              {t(
                LIST_CHANNEL_OPTION?.find(
                  (item: any) => item?.value === cell?.value
                )?.label || "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Start Date"),
        accessor: "start_date",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("End Date"),
        accessor: "end_date",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "150px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`update-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(true);
                      setItemToEdit(item);
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`delete-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-danger edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToDelete(item);
                    }}
                  >
                    <i className="ri-delete-bin-3-fill align-bottom"></i>
                  </Link>
                </li>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, lstCampaign?.meta?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const handleChangeCampaignPicker = (values: any[] = []) => {
    setDateCampaignSearch((_prev: any) => values);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await agencyApi.deleteAgencyCampaign(id);

      if (response?.code === 200 && response?.message === "Success") {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  const onCloseQRCodeClick = () => {
    setPreviewQRCode(null);
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Campaign")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Campaign")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstCampaign?.meta?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Not Yet")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      lstCampaign?.meta?.summary
                                        ?.total_not_yet || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total On-Going")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      lstCampaign?.meta?.summary
                                        ?.total_on_going || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total End")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      lstCampaign?.meta?.summary?.total_end || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>

                    <div className="col-sm-auto text-end">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Button Create Campaign")}
                      </button>
                    </div>
                  </div>
                </CardHeader>

                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Keyword")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Keyword")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_ACTIVE_DISABLE_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_ACTIVE_DISABLE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Campaign Status")}
                          isShow={true}
                        >
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_STATUS_CAMPAIGN_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusCampaignSearch}
                            onChangeSelect={(e: any) =>
                              setStatusCampaignSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_CAMPAIGN}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Channel")} isShow={true}>
                          <DropdownChannel
                            name="channel"
                            placeholder={`${t("Channel")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={channelSearch}
                            onChangeSelect={(e: any) => {
                              setChannelSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("App")} isShow={true}>
                          <DropdownOptionNew
                            name="app_name"
                            dataList={AGENCY_APP_NAME_OPTION || []}
                            placeholder={`${t("Select App Name")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={appNameSearch}
                            onChangeSelect={(e: any) =>
                              setAppNameSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            lstImage={true}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Create Date Range")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Campaign Date Range")}
                          isShow={!!startCampaignDate || !!endCampaignDate}
                        >
                          <DatePickerCustom
                            startDate={startCampaignDate || null}
                            endDate={endCampaignDate || null}
                            onChangePicker={handleChangeCampaignPicker}
                            placeholder={t('Select Campaign Date Range')}
                          />
                        </LabelWrapper>
                      </Col> */}

                      <Col
                        sm={12}
                        md={6}
                        xl={6}
                        xxl={6}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={lstCampaign?.list?.length ? lstCampaign?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={lstCampaign?.meta?.total}
                      customPageCount={Math.ceil(
                        Number(lstCampaign?.meta?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isCampaignLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <CampaignForm
            setIsOpen={setIsOpen}
            id={itemToEdit?.id}
            setItemToEdit={setItemToEdit}
            triggerRefresh={triggerRefresh}
          />
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Campain")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {previewQRCode && (
          <ModalPreviewQRCode
            itemQRCode={previewQRCode}
            onCloseQRCodeClick={onCloseQRCodeClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default CampaignList;
